'use client';

import GloLayout from 'lowcode/common/GloLayout';
import { useRouter } from 'next/router';
import { useMemo } from 'react';

import { LangText } from '@elem/compBlog/details/delta-catalog/LangText';

import './index.scss';

type CatalogItem = {
    title: string;
    id: string;
};

type ContentProps = {
    id: string;
    data?: any;
    tempData?: any;
};
const getCatalogTitleList = (theTemp: any, theData: any) => {
    const result = [];
    for (let i = 0; i < theTemp.length; i++) {
        const itemA: any = theTemp[i];
        if (itemA.name === 'BlogTitle') {
            const itemB = theData[itemA.id];
            if (!itemB) {
                continue;
            }
            if (itemB.type === 'H1') {
                continue;
            }
            if (itemB.type === 'H2') {
                result.push({
                    title: itemB.title,
                    id: `#${itemA.id}`,
                });
            }
        }
    }
    return result;
};

export default function Content({ id, data = {}, tempData = {} }: ContentProps) {
    const { locale: routerLocale = 'us' } = useRouter();
    const locale = data.locale || tempData.locale || routerLocale || 'us';
    const langText = LangText[locale] || LangText.us;

    const theTempFromData = Array.isArray(data.theTemp) ? data.theTemp : [];
    const theDataFromData = typeof data.theData === 'object' && data.theData ? data.theData : {};

    const tempTemp = Array.isArray(tempData.theTemp) ? tempData.theTemp : [];
    const tempDataMap = typeof tempData.theData === 'object' && tempData.theData ? tempData.theData : {};

    const catalogTemp = tempTemp.length ? tempTemp : theTempFromData;
    const catalogData = Object.keys(tempDataMap).length ? tempDataMap : theDataFromData;


    const catalogList: CatalogItem[] = useMemo(() => {
        return getCatalogTitleList(catalogTemp, catalogData);
    }, [catalogTemp, catalogData]);

    return (
        <GloLayout className={`editor-blog-nav editor-blog-nav-open`} id={id}>
            <div className="editor-blog-nav-box">
                <div className="editor-blog-nav-box-header" >
                    {langText.TableOfContents}
                </div>
                <ul className="editor-blog-nav-box-list">
                    {catalogList.map((item, index) => (
                        <li key={item.id} className="editor-blog-nav-box-item">
                            <span className="editor-blog-nav-box-item-index">
                                {index + 1}
                            </span>
                            <a href={item.id} className="editor-blog-nav-box-item-link">
                                {item.title}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </GloLayout>
    );
}